var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/index.tsx
import {
  useBoolean,
  useBreakpointValue,
  useClipboard,
  useConst,
  useControllableProp,
  useControllableState,
  useDimensions,
  useDisclosure,
  useMediaQuery,
  useMergeRefs,
  useOutsideClick,
  usePrefersReducedMotion,
  useTheme,
  useToken
} from "@chakra-ui/react";

// src/use-widget/useWidget.ts
import { axiosETAGCache } from "axios-etag-cache";
import { useQuery } from "@tanstack/react-query";
import { getAppConfig } from "@telescope/cassini-utilities";
import axios from "axios";
var axiosWithETAGCache = axiosETAGCache(axios);
var MIN_POLLING_RATE = 5e3;
var useWidget = (options) => {
  var _a, _b, _c, _d, _e;
  const { appHash, widgetUrl, shouldPollWidget } = getAppConfig();
  const hash = (_b = (_a = options == null ? void 0 : options.widgetStateOptions) == null ? void 0 : _a.apiHash) != null ? _b : appHash;
  const baseURL = (_d = (_c = options == null ? void 0 : options.widgetStateOptions) == null ? void 0 : _c.apiUrl) != null ? _d : widgetUrl;
  const pollingRate = (_e = options == null ? void 0 : options.widgetStateOptions) == null ? void 0 : _e.pollingRate;
  const getData = () => __async(void 0, null, function* () {
    var _a2, _b2, _c2;
    const { data, headers } = yield axiosWithETAGCache.get(hash, { baseURL });
    if (!data.name) {
      throw new Error("Invalid Widget Id");
    }
    const widgetData = __spreadValues({
      name: data.name,
      snapshot: (_a2 = data.snapshot) == null ? void 0 : _a2.data,
      widget: data.data,
      sid: (_b2 = data.snapshot) == null ? void 0 : _b2.snapshot_id,
      nextSnapshotId: data.next_snapshot_id,
      nextSchedule: data.next_schedule,
      currentTimestamp: data.current_timestamp
    }, ((_c2 = options == null ? void 0 : options.widgetStateOptions) == null ? void 0 : _c2.includeServerTimestamp) && { serverTimestamp: headers.date });
    return widgetData;
  });
  const queryKey = ["widget", hash];
  const queryOptions = __spreadValues({
    enabled: !!hash,
    staleTime: Infinity
  }, options);
  if (shouldPollWidget && pollingRate && pollingRate > MIN_POLLING_RATE) {
    queryOptions.refetchInterval = pollingRate;
  }
  return useQuery(queryKey, getData, queryOptions);
};

// src/use-vote/useVote.tsx
import { useCallback, createContext, useContext } from "react";
import { getAppConfig as getAppConfig2 } from "@telescope/cassini-utilities";

// src/use-vote/constants.ts
var VoteAPIAuthType = {
  HEADER_AUTH: 1,
  BODY_AUTH: 2
};
var VoteAPIResponseCode = {
  GENERAL_INVALID: "16",
  EXPIRED_ACCESS_TOKEN: "17",
  COMCAST_INVALID_PARTNER: "18",
  BAD_USER_STATE: "19",
  VALID: "20",
  OVERLIMIT: "21",
  OUT_OF_GEO: "22",
  REGION_NOT_FOUND: "23",
  PROFANITY_FILTERED: "24",
  OPTION_INVALID: "25",
  VALID_OPTIN: "30",
  OPTIN_EXISTS: "31",
  CATEGORY_NOT_PROVIDED: "32",
  AGE_NOT_PROVIDED: "34",
  OTHER: "35",
  DATA_NOT_PROVIDED: "36",
  AGE_INVALID: "37",
  WINDOW: "40",
  TRANSACTION_REJECTED: "86",
  SUSPICIOUS_TRANSACTION: "87"
};

// src/use-vote/api.ts
import axios2 from "axios";
import {
  convertToQspString,
  createHash,
  fixedEncodeURIComponent,
  sortObjectByKeys
} from "@telescope/cassini-utilities";
var makeVoteAPIRequest = (payload, endpoint, secret, postbody, authType) => __async(void 0, null, function* () {
  const qsp = convertToQspString(payload, true);
  let combinedParams = qsp;
  let formData;
  if (postbody) {
    const bodySorted = sortObjectByKeys(__spreadValues({}, postbody));
    const bodyParams = convertToQspString(bodySorted, false);
    combinedParams += `&${bodyParams}`;
    formData = convertToQspString(bodySorted, true);
  }
  const hash = createHash(combinedParams, secret);
  const encodedHash = fixedEncodeURIComponent(hash);
  const url = `${endpoint}?${qsp}`;
  const options = {
    headers: { "content-type": "application/x-www-form-urlencoded" },
    data: void 0,
    url,
    method: "post"
  };
  switch (authType) {
    case VoteAPIAuthType.HEADER_AUTH:
      options.headers = __spreadProps(__spreadValues({}, options.headers), { Authorization: hash });
      options.data = formData;
      break;
    case VoteAPIAuthType.BODY_AUTH:
    default:
      options.data = `Authorization=${encodedHash}`;
      break;
  }
  const res = yield axios2(options);
  return res.data;
});

// src/use-vote/useVote.tsx
import { jsx } from "react/jsx-runtime";
function useVoteApi(settings, options = {}) {
  const { isDevMode, connectUrl } = getAppConfig2();
  const { apiKey, versionId } = settings;
  const { authType = VoteAPIAuthType.HEADER_AUTH, devMode = isDevMode } = options;
  const API_ENDPOINT = options.apiUrl || connectUrl;
  const vote = useCallback(
    (..._0) => __async(this, [..._0], function* (params = {}, postbody = void 0) {
      if (!apiKey || !versionId) {
        console.error("Vote call failed. apiKey and versionId must be provided.");
        return {};
      }
      if (devMode) {
        return {
          response_code: VoteAPIResponseCode.VALID
        };
      }
      const payload = __spreadValues({
        apiKey,
        timestamp: Date.now()
      }, params);
      try {
        const res = yield makeVoteAPIRequest(payload, API_ENDPOINT, versionId, postbody, authType);
        return res;
      } catch (err) {
        console.error("Vote call failed. Error: ", err);
        return {};
      }
    }),
    [apiKey, versionId, API_ENDPOINT, authType, devMode]
  );
  return vote;
}
var VoteApiContext = createContext(void 0);
var VoteApiProvider = ({
  children,
  settings,
  options
}) => {
  const vote = useVoteApi(settings, options);
  return /* @__PURE__ */ jsx(VoteApiContext.Provider, { value: vote, children });
};
function useVote() {
  const context = useContext(VoteApiContext);
  if (context === void 0) {
    throw new Error("useVote must be used within a VoteApiContext");
  }
  return context;
}

// src/use-memo-compare/useMemoCompare.ts
import { useEffect, useRef } from "react";
var useMemoCompare = (next, compare) => {
  const previousRef = useRef();
  const previous = previousRef.current;
  const isEqual2 = compare(previous, next);
  useEffect(() => {
    if (!isEqual2) {
      previousRef.current = next;
    }
  });
  return isEqual2 ? previous : next;
};

// src/use-countdown/useCountdown.ts
import { useEffect as useEffect3, useState, useCallback as useCallback2 } from "react";

// src/use-interval/useInterval.ts
import { useEffect as useEffect2, useRef as useRef2 } from "react";
function useInterval(callback, delay, immediate, memoizeCallback = true) {
  const savedCallback = useRef2(callback);
  const callbackDep = memoizeCallback ? null : callback;
  useEffect2(() => {
    savedCallback.current = callback;
  }, [callback]);
  useEffect2(() => {
    if (!immediate)
      return;
    if (delay === null)
      return;
    savedCallback.current();
  }, [immediate, callbackDep, delay]);
  useEffect2(() => {
    let id;
    function tick() {
      const ret = savedCallback.current();
      if (ret instanceof Promise) {
        ret.then(() => {
          if (delay !== null) {
            id = window.setTimeout(tick, delay);
          }
        });
      } else {
        if (delay !== null) {
          id = window.setTimeout(tick, delay);
        }
      }
    }
    if (delay !== null) {
      id = window.setTimeout(tick, delay);
      return () => {
        id && clearTimeout(id);
      };
    }
  }, [delay, callbackDep]);
}

// src/use-countdown/utils.ts
import {
  differenceInYears,
  differenceInMonths,
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
  addYears,
  addMonths,
  addDays,
  addHours,
  addMinutes
} from "date-fns";
function getTimeDifference(start, end) {
  const diff = end.getTime() - start.getTime();
  return diff <= 0 ? 0 : diff;
}
function getDuration(initialStart, end, units) {
  let remaining = 0;
  const countdown = {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  };
  let start = initialStart;
  if (units.years) {
    remaining = differenceInYears(end, start);
    countdown.years = Math.max(0, remaining);
    start = addYears(start, remaining);
  }
  if (units.months) {
    remaining = differenceInMonths(end, start);
    countdown.months = Math.max(0, remaining);
    start = addMonths(start, remaining);
  }
  if (units.days) {
    remaining = differenceInDays(end, start);
    countdown.days = Math.max(0, remaining);
    start = addDays(start, remaining);
  }
  if (units.hours) {
    remaining = differenceInHours(end, start);
    countdown.hours = Math.max(0, remaining);
    start = addHours(start, remaining);
  }
  if (units.minutes) {
    remaining = differenceInMinutes(end, start);
    countdown.minutes = Math.max(0, remaining);
    start = addMinutes(start, remaining);
  }
  if (units.seconds) {
    remaining = differenceInSeconds(end, start);
    countdown.seconds = Math.max(0, remaining);
  }
  return countdown;
}

// src/use-countdown/useCountdown.ts
var defaultUnits = {
  years: true,
  months: true,
  days: true,
  hours: true,
  minutes: true,
  seconds: true
};
var useCountdown = (endTime, options = {}) => {
  const now = /* @__PURE__ */ new Date();
  const { interval = 1e3, onTick, onEnd, units = defaultUnits } = options;
  const [remaining, setRemaining] = useState(() => getTimeDifference(now, endTime));
  const count = remaining > 0 ? Math.ceil(remaining / interval) : 0;
  const onTickCallback = useCallback2(
    (remainingTime) => {
      if (onTick) {
        onTick(remainingTime);
      }
    },
    [onTick]
  );
  const tick = useCallback2(() => {
    const timeAtTick = /* @__PURE__ */ new Date();
    const timeDiff = getTimeDifference(timeAtTick, endTime);
    if (timeDiff === 0) {
      setRemaining(timeDiff);
      return;
    }
    onTickCallback(timeDiff);
    setRemaining(timeDiff);
  }, [endTime, onTickCallback]);
  useEffect3(() => {
    if (count === 0 && onEnd) {
      onEnd();
    }
  }, [count, onEnd]);
  useEffect3(() => {
    const timeDiff = getTimeDifference(now, endTime);
    if (!remaining && timeDiff > 0)
      tick();
  }, [endTime]);
  useInterval(tick, count ? interval : null, true);
  const duration = getDuration(now, endTime, units);
  return __spreadProps(__spreadValues({}, duration), { totalRemaining: remaining });
};

// src/use-geo/useGeo.ts
import { useState as useState2, useEffect as useEffect4, useCallback as useCallback3 } from "react";

// src/use-geo/api.ts
import axios3 from "axios";
var fetchGeo = () => {
  return axios3.get("/api/getregion.json").then((res) => {
    return res.data;
  }).catch((err) => {
    console.log("Cannot get geo data. Error: ", err);
    return null;
  });
};

// src/use-geo/utils.ts
var checkIfInRegion = (userCountry, countryList, listType) => {
  if (!userCountry || !countryList) {
    return null;
  }
  const countriesArray = typeof countryList === "string" ? countryList.split(",") : countryList;
  const countries = countriesArray.map((s) => s.trim());
  let allowed;
  if (listType === "inclusive") {
    allowed = countries.indexOf(userCountry) >= 0;
  } else {
    allowed = !(countries.indexOf(userCountry) >= 0);
  }
  return allowed;
};

// src/use-geo/useGeo.ts
function useGeo(countries, options = {}) {
  const [isLoading, setIsLoading] = useState2(true);
  const { listType = "inclusive", allowAprUsers = true } = options;
  const [inRegion, setInRegion] = useState2(null);
  const [data, setData] = useState2({});
  const [aprAllowed, setAprAllowed] = useState2(true);
  const handleGeo = useCallback3(() => __async(this, null, function* () {
    const geoData = yield fetchGeo();
    geoData && setIsLoading(false);
    const isInRegion = geoData.geoheaders && (countries.length ? checkIfInRegion(geoData.geoheaders.country, countries, listType) : true);
    const userAprEnabled = geoData.geoheaders.apr;
    userAprEnabled && setAprAllowed(allowAprUsers);
    setInRegion(isInRegion);
    setData(geoData.geoheaders);
  }), [countries, listType, allowAprUsers]);
  useEffect4(() => {
    if (countries === void 0 || !isLoading)
      return;
    handleGeo();
  }, [countries, handleGeo, isLoading]);
  return { data, inRegion, aprAllowed, isLoading, geoAllowed: inRegion && aprAllowed };
}

// src/use-pym/usePym.tsx
import { getQSPs } from "@telescope/cassini-utilities";
import { Child } from "pym.js";
import { createContext as createContext2, useContext as useContext2, useMemo } from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var PYM_PARENT_ID = "telescope-app";
var loadPym = () => {
  if (window.self !== window.top) {
    const { childId } = getQSPs();
    const pymParentId = childId || PYM_PARENT_ID;
    const pymChild = new Child({
      polling: 500,
      id: pymParentId
    });
    return pymChild;
  }
  return null;
};
var PymContext = createContext2({
  pym: null
});
var PymProvider = ({ children }) => {
  const context = useMemo(() => {
    const pym = loadPym();
    return { pym };
  }, []);
  return /* @__PURE__ */ jsx2(PymContext.Provider, { value: context, children });
};
function usePym() {
  const context = useContext2(PymContext);
  if (context === void 0) {
    throw new Error("usePym must be used within a PymContext");
  }
  return context;
}

// src/use-refresh-token/useRefreshToken.ts
import { useRef as useRef3, useEffect as useEffect5 } from "react";
var useRefreshToken = (token) => {
  const ref = useRef3();
  useEffect5(() => {
    if (!ref.current) {
      ref.current = token;
    }
    if (ref.current !== token) {
      window.location.reload();
    }
  }, [token]);
};

// src/use-facebook-login/types.ts
var LoginFlow = /* @__PURE__ */ ((LoginFlow2) => {
  LoginFlow2["AUTO"] = "auto";
  LoginFlow2["SDK"] = "jssdk";
  LoginFlow2["MANUAL"] = "manual";
  return LoginFlow2;
})(LoginFlow || {});

// src/use-facebook-login/useFacebookLogin.tsx
import { createContext as createContext3, useCallback as useCallback4, useContext as useContext3, useEffect as useEffect6, useRef as useRef4, useState as useState3, useMemo as useMemo2 } from "react";
import { createStorage, isWebview } from "@telescope/cassini-utilities";
import { isEqual } from "lodash-es";
import Axios from "axios";

// src/use-facebook-login/facebookUtils.ts
var FACEBOOK_SDK_VERSION = "v13.0";
function FB() {
  return window.FB;
}
function loadSdkAsynchronously() {
  const id = "facebook-jssdk";
  if (document.getElementById(id)) {
    return;
  }
  const js = document.createElement("script");
  js.id = id;
  js.async = true;
  js.defer = true;
  js.crossOrigin = "anonymous";
  js.src = `https://connect.facebook.net/en_US/sdk.js`;
  document.body.prepend(js);
}
function fbLogin(options) {
  return new Promise((resolve) => {
    FB().login((response) => {
      resolve(response);
    }, options);
  });
}
function fbGetLoginStatus() {
  return new Promise((resolve) => {
    FB().getLoginStatus((response) => {
      resolve(response);
    });
  });
}
function getAppStateFromHash() {
  var _a, _b;
  const hash = (_a = window.location.hash) != null ? _a : "";
  const params = new URLSearchParams(hash.substring(1));
  return (_b = params.get("state")) != null ? _b : void 0;
}
function getAccessTokenFromHash(store) {
  var _a, _b, _c;
  const hash = (_a = window.location.hash) != null ? _a : "";
  const params = new URLSearchParams(hash.substring(1));
  if (params.get("access_token") && params.get("expires_in")) {
    const accessToken = (_b = params.get("access_token")) != null ? _b : "";
    const expiresIn = (_c = params.get("expires_in")) != null ? _c : "0";
    const expiresAt = String((/* @__PURE__ */ new Date()).getTime() + parseInt(expiresIn, 10) * 1e3);
    store.setItem("accessToken", accessToken, parseInt(expiresAt, 10));
    return accessToken;
  }
  return void 0;
}
function getAccessTokenFromStorage(store) {
  const accessToken = store.getItem("accessToken");
  if (accessToken) {
    return accessToken;
  }
  store.removeItems("accessToken");
  return null;
}

// src/use-facebook-login/useFacebookLogin.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var FacebookLoginContext = createContext3(void 0);
var FacebookLoginProvider = ({
  appId,
  storagePrefix,
  persistLogin = true,
  loginFlow = "auto" /* AUTO */,
  version = FACEBOOK_SDK_VERSION,
  additionalSdkOptions = {},
  children,
  isLoginEnabled = true
}) => {
  var _a;
  const isInitialized = (_a = window.fbAsyncInit) == null ? void 0 : _a.hasRun;
  const [isLoaded, setIsLoaded] = useState3(isInitialized);
  const store = useMemo2(() => {
    return createStorage(storagePrefix);
  }, [storagePrefix]);
  if (loginFlow === "auto" /* AUTO */) {
    loginFlow = isWebview() ? "manual" /* MANUAL */ : "jssdk" /* SDK */;
  }
  const additionalOptions = useMemoCompare(additionalSdkOptions, (prev, next) => {
    return isEqual(prev, next);
  });
  const state = useMemo2(() => {
    return {
      appId,
      isLoaded,
      version,
      loginFlow,
      persistLogin,
      store,
      isLoginEnabled
    };
  }, [appId, isLoaded, version, loginFlow, persistLogin, store, isLoginEnabled]);
  useEffect6(() => {
    if (!isLoaded && appId && isLoginEnabled && loginFlow === "jssdk" /* SDK */) {
      loadSdkAsynchronously();
      window.fbAsyncInit = function() {
        FB().init(__spreadValues({
          appId,
          version
        }, additionalOptions));
        setIsLoaded(true);
      };
    } else if (appId && loginFlow === "manual" /* MANUAL */) {
      setIsLoaded(true);
    }
  }, [isLoaded, version, appId, additionalOptions, loginFlow, isLoginEnabled]);
  return /* @__PURE__ */ jsx3(FacebookLoginContext.Provider, { value: state, children: (isLoaded || !isLoginEnabled) && children });
};
var defaultLoginOptions = {
  scope: "",
  return_scopes: true,
  response_type: "token granted_scopes",
  auth_type: "rerequest"
};
var useFacebookLogin = (loginHandler, logoutHandler, errorHandler) => {
  const context = useContext3(FacebookLoginContext);
  if (!context) {
    throw new Error("useFacebookLogin must be used within a FacebookLoginProvider.");
  }
  const { isLoaded, appId, version, persistLogin, store, loginFlow } = context;
  const loginHandlerRef = useRef4(loginHandler);
  const logoutHandlerRef = useRef4(logoutHandler);
  const errorHandlerRef = useRef4(errorHandler);
  const getUserData = useCallback4(
    (accessToken) => __async(void 0, null, function* () {
      const fields = ["first_name", "last_name", "name", "id", "email", "permissions"].join(",");
      const res = yield Axios.get(
        `https://graph.facebook.com/${version}/me?fields=${fields}&access_token=${accessToken}`
      );
      const response = res.data;
      return response;
    }),
    [version]
  );
  const logout = useCallback4(() => {
    if (loginFlow === "jssdk" /* SDK */) {
      FB().getLoginStatus((response) => {
        if (response && response.status === "connected") {
          FB().logout(() => {
            logoutHandlerRef.current();
          });
        }
      });
    } else {
      store.removeItem("accessToken");
      logoutHandlerRef.current();
    }
  }, [store, loginFlow]);
  const login = useCallback4(
    (redirectUri, appState = "", options) => __async(void 0, null, function* () {
      const mergedOptions = __spreadValues(__spreadValues({}, defaultLoginOptions), options);
      let res = {
        status: "unknown",
        user: null
      };
      if (loginFlow === "jssdk" /* SDK */) {
        res = yield fbLogin(mergedOptions);
        if (res.status === "connected" && res.authResponse) {
          const { accessToken } = res.authResponse;
          try {
            const userData = yield getUserData(accessToken);
            loginHandlerRef.current(userData, appState, logout);
            return __spreadProps(__spreadValues({}, res), { user: __spreadValues({}, userData) });
          } catch (e) {
            errorHandlerRef.current(e);
          }
        }
      } else {
        const query = new URLSearchParams({
          client_id: appId,
          response_type: mergedOptions.response_type || "token granted_scopes",
          auth_type: mergedOptions.auth_type || "rerequest",
          scope: mergedOptions.scope || "",
          redirect_uri: redirectUri,
          state: appState
        });
        window.location.href = `https://www.facebook.com/${version}/dialog/oauth?${query}`;
      }
      return res;
    }),
    [appId, getUserData, loginFlow, logout, version]
  );
  const restoreLogin = useCallback4(() => __async(void 0, null, function* () {
    let accessToken = "";
    if (loginFlow === "jssdk" /* SDK */) {
      const res = yield fbGetLoginStatus();
      if (res.authResponse) {
        accessToken = res.authResponse.accessToken;
      }
    } else {
      accessToken = getAccessTokenFromStorage(store) || getAccessTokenFromHash(store) || "";
    }
    if (accessToken) {
      try {
        const userData = yield getUserData(accessToken);
        if (loginFlow === "manual" /* MANUAL */) {
          const appState = getAppStateFromHash();
          loginHandlerRef.current(userData, appState, logout);
        } else {
          loginHandlerRef.current(userData, void 0, logout);
        }
      } catch (e) {
        store.removeItem("accessToken");
        errorHandlerRef.current(e);
      }
      window.location.hash = "";
    }
  }), [getUserData, loginFlow, logout, store]);
  useEffect6(() => {
    if (!isLoaded)
      return;
    if (persistLogin || getAccessTokenFromHash(store) && loginFlow === "manual" /* MANUAL */) {
      restoreLogin();
    }
  }, [persistLogin, isLoaded, restoreLogin, loginFlow]);
  return {
    login,
    logout,
    getUserData
  };
};
export {
  FacebookLoginProvider,
  LoginFlow,
  PymProvider,
  VoteAPIAuthType,
  VoteAPIResponseCode,
  VoteApiContext,
  VoteApiProvider,
  useBoolean,
  useBreakpointValue,
  useClipboard,
  useConst,
  useControllableProp,
  useControllableState,
  useCountdown,
  useDimensions,
  useDisclosure,
  useFacebookLogin,
  useGeo,
  useInterval,
  useMediaQuery,
  useMemoCompare,
  useMergeRefs,
  useOutsideClick,
  usePrefersReducedMotion,
  usePym,
  useRefreshToken,
  useTheme,
  useToken,
  useVote,
  useVoteApi,
  useWidget
};
